import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import {
  AttackSurfaceSelection,
  AttackSurfaceSelector,
} from '@/components/AttackSurfaceSelector';
import { OrganizationHeader } from '@/components/OrganizationHeader';
import { Tooltip } from '@/components/Tooltip';
import { StepProps } from '@/sections/customerManagement/components/modals/AddCustomerModal/AddCustomerModal.types';

/**
 * Step 2: Attack Surface - Select which attack surfaces to monitor
 */
export const AttackSurfaceStep: React.FC<StepProps> = ({
  formData,
  setFormData,
}) => {
  const handleAttackSurfaceChange = (
    newAttackSurface: AttackSurfaceSelection
  ) => {
    setFormData(prev => ({
      ...prev,
      attack_surface: newAttackSurface,
    }));
  };

  return (
    <div className="flex flex-col gap-8">
      <OrganizationHeader
        displayName={formData.settings_display_name}
        profilePicture={formData.profile_picture}
        subtitle="Select which attack surfaces to target for this customer"
        className="mb-8"
      />

      {/* Attack Surface Selection Header */}
      <div className="mb-6 flex items-center gap-2">
        <h3 className="text-chariot-text-primary text-base font-medium">
          Select Attack Surfaces{' '}
          <span className="text-chariot-stroke-critical">*</span>
        </h3>
        <Tooltip title="Choose which attack surfaces to monitor for this customer.">
          <QuestionMarkCircleIcon className="text-chariot-text-secondary hover:text-chariot-text-primary h-4 w-4 cursor-help" />
        </Tooltip>
      </div>

      {/* Attack Surface Selection */}
      <AttackSurfaceSelector
        value={formData.attack_surface}
        onChange={handleAttackSurfaceChange}
        variant="list"
        requiredOptions={[]}
        showDescriptions={true}
        showCheckIcon={true}
      />
    </div>
  );
};
